import {
  ProductLabelDomainType,
  type ProductWithPermissionsFragment,
} from '@ori/favorites-fetching';
import type { Product } from '@ori/graphql-schema';

export const products: Product[] = [
  {
    backInStockAvailability: {
      showBackInStockNotification: false,
    },
    concept: {
      brand: {
        name: 'Love Nature',
        brandId: '1',
        taxonomyId: '1',
      },
      conceptCode: '41298',
      labels: [
        {
          labelKey: 'NewEdition',
          productLabelDomain: ProductLabelDomainType.Deal,
          title: undefined,
        },
        {
          labelKey: 'New',
          productLabelDomain: ProductLabelDomainType.Deal,
          title: 'New',
        },
        {
          labelKey: 'AddToBasketVisible',
          productLabelDomain: ProductLabelDomainType.Shopping,
          title: undefined,
        },
      ],
      name: 'Shampoo For Dry Hair with Organic Wheat & Coconut',
      products: [
        {
          colorHexCode: undefined,
          colorImageUrl: '',
          productCode: '41298',
        },
      ],
      ratingAverage: 4.7857,
      ratingCount: 42,
    },
    formattedPrice: {
      price: {
        basicCataloguePrice: '£10.00',
        currentPrice: '£7.99',
      },
    },
    labels: [
      {
        labelKey: 'NewEdition',
        productLabelDomain: ProductLabelDomainType.Deal,
        title: undefined,
      },
      {
        labelKey: 'New',
        productLabelDomain: ProductLabelDomainType.Deal,
        title: 'New',
      },
      {
        labelKey: 'AddToBasketVisible',
        productLabelDomain: ProductLabelDomainType.Shopping,
        title: undefined,
      },
    ],
    imageUrl:
      'https://media-stg-cdn.oriflame.com/productImage?externalMediaId=product-management-media%2f41298%2fUK%2f41298.png%3fversion%3d1677487508',
    productCode: '41298',
    replacedByProduct: undefined,
    replacementForProduct: {
      productCode: '33641',
    },
  },
  {
    backInStockAvailability: {
      showBackInStockNotification: false,
    },
    concept: {
      brand: {
        name: 'Love Nature',
        brandId: '1',
        taxonomyId: '1',
      },
      conceptCode: '41265',
      labels: [
        {
          labelKey: 'New',
          productLabelDomain: ProductLabelDomainType.Deal,
          title: 'New',
        },
        {
          labelKey: 'AddToBasketVisible',
          productLabelDomain: ProductLabelDomainType.Shopping,
          title: undefined,
        },
      ],
      name: 'Refreshing Shower Gel with Organic Coconut Water & Melon',
      products: [
        {
          colorHexCode: undefined,
          colorImageUrl: '',
          productCode: '41265',
        },
      ],
      ratingAverage: 4.8609,
      ratingCount: 115,
    },
    formattedPrice: {
      price: {
        basicCataloguePrice: '£10.00',
        currentPrice: '£7.99',
      },
    },
    labels: [
      {
        labelKey: 'New',
        productLabelDomain: ProductLabelDomainType.Deal,
        title: 'New',
      },
      {
        labelKey: 'AddToBasketVisible',
        productLabelDomain: ProductLabelDomainType.Shopping,
        title: undefined,
      },
    ],
    imageUrl:
      'https://media-stg-cdn.oriflame.com/productImage?externalMediaId=product-management-media%2f41265%2fUK%2f41265.png%3fversion%3d1679431503',
    productCode: '41265',
    replacedByProduct: undefined,
    replacementForProduct: undefined,
  },
];

export const productsWithPermissions: ProductWithPermissionsFragment[] = products.map(
  ({ productCode }) => ({ productCode, permission: { canBuy: true, canDisplay: true } }),
);
